module.exports = __webpack_public_path__ + "static/media/Apidae-Form.ce011cb8.svg";